import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const useLangstonContentGet = <T>(contentId: string) => {
  const requestUrl = `${MONOLITH_ORIGIN}/api/v3/content-document/${contentId}/`;
  return useRestQuery<T>(requestUrl);
};

export default useLangstonContentGet;
